import Price from './price';

function Plans(parent, search) {
    Price.call(this, parent, search);
}

Plans.prototype = Object.create(Price.prototype);
Object.defineProperty(Plans.prototype, 'constructor', {
    value: Plans,
    enumerable: false,
    writable: true,
});

export default Plans;
